import React from 'react';

import Image, { ImageLoaderProps } from 'next/image';

import * as S from './styles';

type ImageProps = {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
};

const imgLoader = ({ src, width, quality }: ImageLoaderProps) => {
  return `/tcstore/_next/image?url=${src}&w=${width}&q=${quality || 70}`;
};

// images should into /public/images folder.
const ImageURL = ({ src, alt, width = `auto`, height = `auto`, ...rest }: ImageProps) => (
  <S.Wrapper {...rest}>
    <Image
      // loader={imgLoader}
      src={src}
      alt={alt}
      width={width}
      height={height}
    />
  </S.Wrapper>
);

export default ImageURL;
